import React, { useState, useEffect } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "react-quill/dist/quill.bubble.css";
import "react-quill/dist/quill.core.css";
import { Container } from "reactstrap";
import { NavbarAdmin } from "../../../shared/admin/NavbarAdmin";
import { Link, useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { useSelector } from "react-redux";
import Unauthorized from "../../../shared/Unauthorized";

function Editor(props) {
  const [theme, setTheme] = useState("snow");
  const { id, inputRef, placeholder } = props;
  const { ides, inputRefes, placeholderes } = props;
  const params = useParams();
  const [text, setText] = useState("");
  const [title, setTitle] = useState("");
  const [price, setPrice] = useState("");
  const accessToken = useSelector((state) => state.form.accessToken);
  const navigate = useNavigate();

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/portfolio/info/${params.id}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken,
        },
      })
      .then((response) => {
        setText(response.data.text);
        setTitle(response.data.title);
        setPrice(response.data.price);
      });
  }, [accessToken, params.id]);

  const saveText = () => {
    axios
      .put(
        `${process.env.REACT_APP_BACKEND_URL}/portfolio/update/${params.id}`,
        {
          text: text,
          title: title,
          price: price,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + accessToken,
          },
        }
      )
      .then((response) => {
        navigate("/admin/list/portfolio/");
      });
  };

  if (!accessToken) {
    <Unauthorized />;
  } else if (accessToken) {
    return (
      <>
        <NavbarAdmin />
        <Container className="animate-in">
          <div className="spacer mobile main"></div>
          <div className="d-flex justify-content-evenly align-center">
            <Link className="editor-button left" to="/admin/list/portfolio">
              <button className="send-button editor">ZPĚT</button>
            </Link>
            <Link
              className="editor-button right"
              to={`/admin/add/portfolio/images/list/${params.id}`}
            >
              <button className="send-button editor">OBRÁZKY</button>
            </Link>
          </div>
          <div className="login-form">
            <input
              name="title"
              type="text"
              placeholder="Název"
              className="control"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            />
          </div>
          <ReactQuill
            id={ides}
            ref={inputRefes}
            theme={theme}
            onChange={(value) => setPrice(value)}
            value={price}
            className="mt-3"
            modules={{
              toolbar: {
                ...Editor.modules.toolbar,
                handlers: {},
              },
              ...Editor.modules,
            }}
            formats={Editor.formats}
            bounds={".app"}
            placeholder={"Ceny a nejnutnější informace"}
          />
          <ReactQuill
            id={id}
            ref={inputRef}
            theme={theme}
            className="mt-3"
            onChange={(value) => setText(value)}
            value={text}
            modules={{
              toolbar: {
                ...Editor.modules.toolbar,
                handlers: {},
              },
              ...Editor.modules,
            }}
            formats={Editor.formats}
            bounds={".app"}
            placeholder={"text"}
          />
          <button
            className="send-button save mb-3"
            type="submit"
            onClick={() => saveText()}
          >
            ULOŽIT
          </button>
        </Container>
      </>
    );
  }
}

/*
 * Quill modules to attach to editor
 * See https://quilljs.com/docs/modules/ for complete options
 */
Editor.modules = {
  toolbar: [
    // [{ header: '1' }, { header: '2' }, { font: [] }],
    // [{ size: [] }],
    [{ size: ["small", false, "large", "huge"] }], // custom dropdown
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    ["bold", "italic", "underline", "strike", "blockquote"],
    [
      { list: "ordered" },
      { list: "bullet" },
      { indent: "-1" },
      { indent: "+1" },
    ],
    ["link"],
    ["clean"],
    [{ align: [] }],
  ],
  clipboard: {
    // toggle to add extra line breaks when pasting HTML:
    matchVisual: false,
  },
};
/*
 * Quill editor formats
 * See https://quilljs.com/docs/formats/
 */
Editor.formats = [
  "header",
  "font",
  "size",
  "bold",
  "italic",
  "underline",
  "strike",
  "blockquote",
  "list",
  "bullet",
  "indent",
  "link",
  "image",
  "video",
];

export default Editor;
